<template>
  <nav :class="{ open: navOpen }">
    <div class="logo">
      <full-logo pro />
    </div>

    <nav-item
      as="router-link"
      to="/dashboard"
      icon="space_dashboard"
      text="Dashboard"
      :collapsed="navCollapsed"
    />

    <nav-item
      as="router-link"
      to="/collection"
      icon="view_carousel"
      text="Collection"
      :collapsed="navCollapsed"
    />

    <nav-item
      as="router-link"
      :to="`/sales-history?${salesHistoryQuery}`"
      icon="search"
      text="Sales"
      :collapsed="navCollapsed"
    />

    <nav-item
      as="router-link"
      to="/shop"
      icon="local_offer"
      text="Shop"
      :collapsed="navCollapsed"
    />

    <nav-item
      as="router-link"
      to="/ladder"
      icon="cl_ladder"
      text="Ladder"
      :collapsed="navCollapsed"
    />

    <nav-item
      as="router-link"
      to="/profiles"
      icon="badge"
      text="Profiles"
      :collapsed="navCollapsed"
    />

    <nav-item
      as="router-link"
      to="/showcase"
      icon="public"
      text="Showcase"
      :collapsed="navCollapsed"
    />

    <nav-item
      as="router-link"
      to="/indexes"
      icon="assessment"
      text="Indexes"
      :collapsed="navCollapsed"
    />

    <nav-item
      as="router-link"
      to="/players"
      icon="sports_handball"
      text="Players"
      :collapsed="navCollapsed"
    />

    <nav-item
      as="router-link"
      to="/watchlist"
      icon="visibility"
      text="Watchlist"
      :collapsed="navCollapsed"
    />

    <nav-item
      as="router-link"
      to="/compare"
      icon="multiline_chart"
      text="Compare"
      :collapsed="navCollapsed"
    />

    <nav-item
      as="router-link"
      to="/feed"
      icon="rss_feed"
      text="Feed"
      :collapsed="navCollapsed"
    />

    <nav-item
      as="router-link"
      to="/industry"
      icon="medical_services"
      text="Industry"
      :collapsed="navCollapsed"
    />

    <nav-item
      v-if="isStaff"
      admin
      as="router-link"
      to="/add"
      icon="verified"
      text="Verify"
      :collapsed="navCollapsed"
    />

    <nav-item
      v-if="isAdmin"
      admin
      as="router-link"
      to="/headlines"
      icon="newspaper"
      text="Headlines"
      :collapsed="navCollapsed"
    />

    <nav-item
      v-if="isStaff"
      admin
      as="router-link"
      to="/pending-sales"
      icon="nights_stay"
      text="Review"
      :collapsed="navCollapsed"
    />

    <nav-item
      v-if="isAdmin"
      admin
      as="router-link"
      to="/admin"
      icon="people"
      text="Admin"
      :collapsed="navCollapsed"
    />

    <nav-item
      class="collapse-toggle medium-up"
      as="button"
      :icon="navCollapsed ? 'last_page' : 'first_page'"
      text="Collapse"
      :collapsed="navCollapsed"
      @click="toggleCollapsed"
    />
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import FullLogo from '@cardladder/shared/components/FullLogo';
import NavItem from '@cardladder/shared/components/NavItem';

export default {
  components: {
    FullLogo,
    NavItem,
  },

  data() {
    return {
      navMenuCollapsed: false,
    };
  },

  computed: {
    ...mapState({
      navCollapsed: (state) => state.navCollapsed,
      navOpen: (state) => state.navOpen,
      salesHistoryQuery: (state) => state.salesHistoryQuery,
    }),

    ...mapGetters({
      isAdmin: 'isAdmin',
      isStaff: 'isStaff',
    }),
  },

  methods: {
    toggleCollapsed() {
      this.$store.commit('SET_NAV_COLLAPSED', !this.navCollapsed);
    },
  },
};
</script>

<style lang="scss" scoped>
nav {
  @include overflowY;

  background-color: var(--theme-background);
  width: var(--nav-menu-width);
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  bottom: 0;
  padding: $gp;

  @media($medium-up) {
    border-right: 1px solid var(--theme-border);
  }

  @media($medium-down) {
    @include transition(transform);
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    z-index: 10;
    box-shadow: $elevation-1;

    &.open {
      transform: translateX(0);
    }
  }
}

.logo {
  display: inline-block;
  margin-bottom: $gp;
}

.collapse-toggle {
  margin-top: auto;
  margin-bottom: 0;
}
</style>
